let root;

if (process.env.NODE_ENV === 'development') {
  root = 'sos';
} else {
  root = 'sos';
}

const HOMEPAGE_URL =
  'https://s3.amazonaws.com/sos.texastribune.org/top-news/2018-runoff.json';
const NESTED_RESULTS_URL = `https://s3.amazonaws.com/${root}.texastribune.org/results/2018-primary-runoffs.json`;
const RESULTS_URL = `https://s3.amazonaws.com/${root}.texastribune.org/results/2018-primary-runoffs-flat.json`;
const INDIVIDUAL_RESULT_URL = id =>
  `https://s3.amazonaws.com/${root}.texastribune.org/results/contests/${id}.json`;
const STORY_API_URL = id =>
  `https://www.texastribune.org/api/v1/content/${id}/?format=json&__=${+new Date()}`;

export {
  HOMEPAGE_URL,
  INDIVIDUAL_RESULT_URL,
  NESTED_RESULTS_URL,
  RESULTS_URL,
  STORY_API_URL,
};



// WEBPACK FOOTER //
// ./endpoints.js